import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowLeftRounded, ArrowRightRounded } from '@material-ui/icons';
import cx from 'clsx';
import Carousel from 'react-material-ui-carousel';
import { renderAnswer } from './renderAnswer';
export function renderCarousel(index, carousel, skillApi, cardId, onChange) {
    if (!carousel.contents)
        return null;
    var changePage = function (now, prev) {
        onChange(now, prev);
    };
    var carouselPages = carousel.contents.map(function (content) {
        return (_jsx("div", { className: cx('faq-answer-content__carousel-slide'), children: renderAnswer(content, skillApi, cardId) }, "carousel-".concat(cardId, "-").concat(carousel.id, "-").concat(content.id)));
    });
    return (_jsx(_Fragment, { children: carouselPages && (_jsx(Carousel, { index: index, swipe: true, NextIcon: _jsx(ArrowRightRounded, {}), PrevIcon: _jsx(ArrowLeftRounded, {}), navButtonsAlwaysVisible: true, indicatorIconButtonProps: {
                className: cx('faq-answer-content__carousel-indicator-button'),
            }, navButtonsProps: {
                className: cx('faq-answer-content__carousel-nav-button'),
            }, autoPlay: false, animation: 'slide', onChange: changePage, children: carouselPages })) }));
}
//# sourceMappingURL=renderCarousel.js.map